import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CancelIconComponent } from '@plugins/client/icons/cancel-icon';

import { MultiLanguageActionComponent } from '../action-button/action-button.component';

@Component({
  selector: 'plugins-multilanguage-remove',
  imports: [MultiLanguageActionComponent, CancelIconComponent],
  template: `<plugins-multilanguage-action
    (clicked)="clicked.emit()"
    [ariaLabel]="ariaLabel"
    [disabled]="disabled"
    [tooltip]="tooltip"
  >
    <icon-cancel [size]="19"
  /></plugins-multilanguage-action>`,
  styleUrl: './remove-language.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultilanguageRemoveComponent extends MultiLanguageActionComponent {}
